import { baseAPI } from '@/api/axios';

const getOptions = (
  tenantId,
  groupId = null,
  contentType = 'application/json'
) => {
  const headers = { 'Content-Type': contentType };
  if (tenantId) headers['TenantId'] = tenantId;
  if (groupId) headers['Group-Id'] = groupId;
  return { headers };
};

export default {
  getGroupHierarchy({ orgId }) {
    return baseAPI.get(`groups/hierarchy`, getOptions(orgId));
  },
  findAssignedAsHierarchy({ orgId, groupId, payload }) {
    return baseAPI.post(
      `courseAssignment/users/findAssignedAsHierarchy`,
      payload,
      getOptions(orgId, groupId)
    );
  },
  getGroupUsers({ orgId, groupId, sortBy, ...params }) {
    return baseAPI.get(
      `groups/users/search${sortBy ? `?sortBy=${sortBy}` : ''}`,
      { ...getOptions(orgId, groupId), params }
    );
  },
};
